import { render } from "./020-SummaryReport.vue?vue&type=template&id=2ef1cde8&scoped=true"
import script from "./020-SummaryReport.vue?vue&type=script&lang=js"
export * from "./020-SummaryReport.vue?vue&type=script&lang=js"

import "./020-SummaryReport.vue?vue&type=style&index=0&id=2ef1cde8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ef1cde8"]])

export default __exports__